<template>
  <main class="common-container">
    <section class="page-title flash-title common-padding">
      <h2>{{ $t("menu.alphaChart") }}</h2>
    </section>

    <section class="explanation-container center">
      <img :src="explainImg" alt="" />

      <ul class="color-circle">
        <li class="color-circle__item">
          <p v-html="$t('alphaExp.descText1')"></p>
        </li>
        <li class="color-circle__item">
          <p v-html="$t('alphaExp.descText2')"></p>
        </li>
        <li class="color-circle__item">
          <p>{{ $t("alphaExp.descText3") }}</p>
        </li>
        <li class="color-circle__item">
          <p>{{ $t("alphaExp.descText4") }}</p>
        </li>

        <div class="sub-sentence-box">
          <h3>{{ $t("alphaExp.content1.descText1") }}</h3>
          <p class="sentence22" v-html="$t('alphaExp.content1.descText2')"></p>
          <p class="sentence22" v-html="$t('alphaExp.content1.descText3')"></p>
          <p class="sentence22" v-html="$t('alphaExp.content1.descText4')"></p>
        </div>
        <div class="sub-sentence-box">
          <h3>{{ $t("alphaExp.content2.descText1") }}</h3>
          <p class="sentence22" v-html="$t('alphaExp.content2.descText2')"></p>
          <p class="sentence22" v-html="$t('alphaExp.content2.descText3')"></p>
        </div>
        <div class="sub-sentence-box">
          <h3>{{ $t("chart1.trend") }}</h3>
          <p class="sentence22" v-html="$t('alphaExp.content3.descText1')"></p>
        </div>
        <div class="sub-sentence-box">
          <h3>{{ $t("chart1.sr") }}</h3>
          <p class="sentence22" v-html="$t('alphaExp.content4.descText1')"></p>
        </div>
        <div class="sub-sentence-box">
          <h3>{{ $t("kibot.candle") }}</h3>
          <p class="sentence22" v-html="$t('alphaExp.content5.descText1')"></p>
          <p class="sentence22" v-html="$t('alphaExp.content5.descText2')"></p>
        </div>
        <div class="sub-sentence-box">
          <h3>{{ $t("chart1.3ma") }}</h3>
          <p class="sentence22" v-html="$t('alphaExp.content6.descText1')"></p>
        </div>
        <div class="sub-sentence-box">
          <h3>{{ $t("chart1.bb") }}</h3>
          <p class="sentence22" v-html="$t('alphaExp.content7.descText1')"></p>
        </div>
        <div class="sub-sentence-box">
          <h3>MACD</h3>
          <p class="sentence22" v-html="$t('alphaExp.content8.descText1')"></p>
        </div>
      </ul>
    </section>
  </main>
</template>

<script setup>
import { computed, onMounted, onUnmounted } from "vue";
import { useResolutionStore } from "@/store/useResolution";
import alphaImg from "@/assets/images/pages/explanation/alpha/alpha_explanation.png";
import alphaMImg from "@/assets/images/pages/explanation/alpha/alpha_explanation-m.png";

const resolutionStore = useResolutionStore();
const isMobile = computed(() => resolutionStore.isMobile);
// isMobile 값이 변경될 때 자동으로 업데이트됨
const explainImg = computed(() => (isMobile.value ? alphaMImg : alphaImg));

const updateWindowSize = () => {
  resolutionStore.setSize({ width: window.innerWidth });
};

onMounted(() => {
  window.addEventListener("resize", updateWindowSize);
});

onUnmounted(() => {
  window.removeEventListener("resize", updateWindowSize);
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/pages/explanation/common_explanation.scss";
</style>
